<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">UNITE and Conquer</h1>
<p><span>• • •</span></p>
<h1 class="subtitle">How to Build Coalitions That Win—and Last</h1>
<h2 class="author">Kyrsten Sinema</h2><br/>
<div class="image"><img alt="image" src="images/0003.jpg"/></div>
<p><span>Berrett—Koehler Publishers, Inc.<br/>San Francisco a BK Currents book</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?75fb498f